import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "galeria",
  class: "relative scroll-mt-20 py-28 md:py-36"
}
const _hoisted_2 = { class: "mb-16 flex flex-col gap-6 md:mb-20 lg:flex-row lg:items-end lg:justify-between" }
const _hoisted_3 = { class: "eyebrow" }
const _hoisted_4 = { class: "section-title mt-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-molten" }, "Trabajo", -1)
const _hoisted_6 = { class: "max-w-md text-ivory/50 lg:text-right" }
const _hoisted_7 = { class: "grid grid-flow-dense auto-rows-[220px] grid-cols-2 gap-4 md:auto-rows-[280px] lg:grid-cols-4" }
const _hoisted_8 = ["aria-label", "onClick"]
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "pointer-events-none absolute inset-0 -translate-x-full skew-x-[-20deg] bg-gradient-to-r from-transparent via-white/50 to-transparent transition-transform duration-1000 group-hover:translate-x-full" }, null, -1)
const _hoisted_11 = { class: "absolute inset-x-0 bottom-0 flex translate-y-full items-center justify-between bg-gradient-to-t from-ink/95 to-ink/0 px-6 pb-5 pt-12 transition-transform duration-500 group-hover:translate-y-0" }
const _hoisted_12 = { class: "block text-[10px] uppercase tracking-[0.3em] text-copper" }
const _hoisted_13 = { class: "font-display text-lg text-ivory" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-2xl text-copper" }, "＋", -1)
const _hoisted_15 = { class: "rounded-2xl bg-[radial-gradient(circle_at_50%_35%,#ffffff,#efe6da_60%,#d9c9b5)] p-6 shadow-[0_0_80px_-10px_rgba(213,155,106,0.5)]" }
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = { class: "mt-6 text-center" }
const _hoisted_18 = { class: "block text-xs uppercase tracking-[0.3em] text-copper" }
const _hoisted_19 = { class: "font-display text-2xl" }

import { onBeforeUnmount, onMounted, ref, watch } from "vue";
import ContainerComponent from "@/components/base/ContainerComponent.vue";

/* eslint-disable @typescript-eslint/no-var-requires */

export default /*#__PURE__*/_defineComponent({
  __name: 'GalleryComponent',
  setup(__props) {

const items = [
  {
    file: 1,
    title: "Virgen de Guadalupe",
    category: "Escultura",
    span: "row-span-2",
  },
  {
    file: 2,
    title: "Búho del saber",
    category: "Escultura",
    span: "col-span-2 row-span-2",
  },
  { file: 5, title: "Corceles", category: "Escultura", span: "row-span-2" },
  {
    file: 3,
    title: "Llavero escudo",
    category: "Promocional",
    span: "lg:col-span-2",
  },
  {
    file: 4,
    title: "Manada de elefantes",
    category: "Escultura",
    span: "lg:col-span-2",
  },
].map((item) => ({
  ...item,
  src: require(`@/assets/gallery/${item.file}.png`),
}));
/* eslint-enable @typescript-eslint/no-var-requires */

const active = ref<number | null>(null);

const openAt = (i: number) => (active.value = i);
const step = (dir: number) => {
  if (active.value === null) return;
  active.value = (active.value + dir + items.length) % items.length;
};

const onKey = (e: KeyboardEvent) => {
  if (active.value === null) return;
  if (e.key === "Escape") active.value = null;
  if (e.key === "ArrowRight") step(1);
  if (e.key === "ArrowLeft") step(-1);
};

watch(
  active,
  (v) => (document.body.style.overflow = v === null ? "" : "hidden")
);

onMounted(() => window.addEventListener("keydown", onKey));
onBeforeUnmount(() => {
  window.removeEventListener("keydown", onKey);
  document.body.style.overflow = "";
});

return (_ctx: any,_cache: any) => {
  const _directive_reveal = _resolveDirective("reveal")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(ContainerComponent, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_3, [
              _createTextVNode("Galería")
            ])), [
              [_directive_reveal]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("h2", _hoisted_4, [
              _createTextVNode(" Nuestro "),
              _hoisted_5
            ])), [
              [_directive_reveal, 100]
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_6, [
            _createTextVNode(" Una muestra de piezas salidas de nuestro taller. Haz clic en cualquiera para verla de cerca. ")
          ])), [
            [_directive_reveal, 200]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (item, i) => {
            return _withDirectives((_openBlock(), _createElementBlock("button", {
              key: item.file,
              class: _normalizeClass(["group relative overflow-hidden rounded-2xl bg-[radial-gradient(circle_at_50%_35%,#ffffff,#efe6da_55%,#d9c9b5)] text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-copper", item.span]),
              "aria-label": `Ver ${item.title}`,
              onClick: ($event: any) => (openAt(i))
            }, [
              _createElementVNode("img", {
                src: item.src,
                alt: item.title,
                loading: "lazy",
                class: "h-full w-full object-contain p-6 mix-blend-multiply transition-transform duration-700 ease-out group-hover:scale-110"
              }, null, 8, _hoisted_9),
              _hoisted_10,
              _createElementVNode("span", _hoisted_11, [
                _createElementVNode("span", null, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(item.category), 1),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(item.title), 1)
                ]),
                _hoisted_14
              ])
            ], 10, _hoisted_8)), [
              [
                _directive_reveal,
                i * 100,
                void 0,
                { zoom: true }
              ]
            ])
          }), 128))
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      "enter-active-class": "transition duration-300",
      "enter-from-class": "opacity-0",
      "leave-active-class": "transition duration-200",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (active.value !== null)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-[70] flex items-center justify-center bg-ink/95 p-6 backdrop-blur-md",
              role: "dialog",
              "aria-modal": "true",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (active.value = null), ["self"]))
            }, [
              _createElementVNode("button", {
                class: "absolute right-6 top-6 text-3xl text-ivory/60 hover:text-copper",
                "aria-label": "Cerrar",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (active.value = null))
              }, " ✕ "),
              _createElementVNode("button", {
                class: "absolute left-4 top-1/2 -translate-y-1/2 p-4 text-4xl text-ivory/60 hover:text-copper md:left-10",
                "aria-label": "Anterior",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (step(-1)))
              }, " ‹ "),
              _createVNode(_Transition, {
                mode: "out-in",
                "enter-active-class": "transition duration-300 ease-out",
                "enter-from-class": "opacity-0 scale-95",
                "leave-active-class": "transition duration-150",
                "leave-to-class": "opacity-0 scale-95"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock("figure", {
                    key: active.value,
                    class: "flex max-h-full flex-col items-center"
                  }, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("img", {
                        src: _unref(items)[active.value].src,
                        alt: _unref(items)[active.value].title,
                        class: "max-h-[70vh] w-auto max-w-[80vw] object-contain mix-blend-multiply"
                      }, null, 8, _hoisted_16)
                    ]),
                    _createElementVNode("figcaption", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(items)[active.value].category), 1),
                      _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(items)[active.value].title), 1)
                    ])
                  ]))
                ]),
                _: 1
              }),
              _createElementVNode("button", {
                class: "absolute right-4 top-1/2 -translate-y-1/2 p-4 text-4xl text-ivory/60 hover:text-copper md:right-10",
                "aria-label": "Siguiente",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (step(1)))
              }, " › ")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})